import { render } from "./FolderItem.vue?vue&type=template&id=6ce7c6c8&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=ts"
export * from "./FolderItem.vue?vue&type=script&lang=ts"

import "./FolderItem.vue?vue&type=style&index=0&id=6ce7c6c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ce7c6c8"

export default script